<template>
  <div class="autocomplete">
    <v-autocomplete
      v-model="serviceProvider"
      @keyup="search"
      @change="handleSelect"
      @click:clear="clear"
      :no-data-text="$t('serviceProviders.noData')"
      :label="$t('serviceProviders.title')"
      :density="density"
      :items="serviceProviders"
      prepend-inner-icon="mdi-magnify"
      item-value="id"
      item-text="name"
      return-object
      clearable
      outlined
    />
    <v-progress-circular
      v-show="isServiceProvidersLoading"
      class="autocomplete-loading"
      color="primary"
      width="1.5"
      size="13"
      indeterminate
    />
  </div>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from 'vuex'

export default {
  name: 'HServiceProviderSelect',

  props: {
    defaultValue: {
      default: null,
    },

    density: {
      type: 'default' | 'comfortable' | 'compact',
      default: 'default',
    },
  },

  computed: {
    ...mapGetters(['serviceProviders']),
  },

  methods: {
    ...mapActions(['listServiceProviders']),
    ...mapMutations(['setFilters', 'setServiceProviders']),

    handleSelect(value) {
      if (!value) return
      this.$emit('input', this.serviceProvider)
      return
    },

    search({ target }) {
      const term = target?.value
      if (!term && term?.length <= 3) return

      clearTimeout(this.timer)

      this.isServiceProvidersLoading = true
      this.setFilters({ search: term })

      this.timer = setTimeout(() => {
        this.listServiceProviders()
          .finally(() => {
            this.isServiceProvidersLoading = false
            this.setFilters({ search: null })
          })
      }, 1000)
    },

    clear() {
      this.serviceProvider = null
      this.$emit('input', null)
    },
  },

  watch: {
    defaultValue(value) {
      if (!value) return

      this.setServiceProviders([value])
      this.$nextTick(() => this.serviceProvider = value)
    },
  },

  data() {
    return {
      serviceProvider: null,
      isServiceProvidersLoading: false,
      timer: null,
    }
  },
}
</script>

<style scoped>
.autocomplete {
  position: relative;
}

.autocomplete-loading {
  position: absolute;
  top: 28px;
  right: 73px;
  transform: translateY(-50%);
}
</style>

